import React from 'react';

import {SvgProps} from '../../helpers/type';

const Idea = ({className}: SvgProps): JSX.Element => {
    return (
        <svg
            width="18"
            height="26"
            viewBox="0 0 18 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M5.44444 22.2308H12.5556M6.33333 25H11.6667M1 9.30769C1 4.71948 4.58172 1 9 1C13.4183 1 17 4.71948 17 9.30769C17 11.6391 16.0752 13.7463 14.5857 15.2551C13.9275 15.9219 13.4444 16.7896 13.4444 17.7445C13.4444 18.6928 12.7042 19.4615 11.791 19.4615H6.20899C5.29582 19.4615 4.55556 18.6928 4.55556 17.7445C4.55556 16.7896 4.07255 15.9219 3.4143 15.2551C1.92483 13.7463 1 11.6392 1 9.30769Z"
                stroke="#174943"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default Idea;
